const dnsBlue = '#049ee0';
const dnsLightBlue = '#5ED0FF';
const dnsDarkBlue = '#1e5fa6';
const dnsLightGrey = '#ededed';
const dnsGreen = '#008389';
const dnsBlack = '#1a1a1a';
const dnsVlaanderenColor = '#7a7a29';
const dnsBrusselsColor = '#55083f';

const Colors = {
    dnsColorsArray: [
        dnsDarkBlue,
        dnsBlue,
        dnsBlack,
        dnsGreen,
        dnsLightBlue,
        dnsLightGrey,
    ],
    dnsBeColorArray: [
        dnsBlack,
        dnsBrusselsColor,
        dnsVlaanderenColor,
    ],
    dnsBlue,
    dnsDarkBlue,
    dnsLightGrey,
    dnsGreen,
    dnsBlack,
    dnsBrusselsColor,
    dnsVlaanderenColor,
};

export default Colors;
